import classNames from 'classnames'

import { Loader } from '@/shared'
import { type IAdditionalInfo2 } from '@App/types/doctorsType'

import { SectionTitle } from '../SectionTitle/SectionTitle'

import { Description } from './Description/Description'
import style from './DescriptionEditor.module.scss'

interface IProps {
    additionalInfo: IAdditionalInfo2[] | null
    onUpdateAdditionalInfo: (dto: IAdditionalInfo2[], onSuccess?: () => void) => void
    onGetAdditionalInfoActualData: (onSuccess?: () => void) => void
    isFetchingAdditionalInfo: boolean
}

export const DescriptionEditor = (props: IProps) => {
    const { additionalInfo, onUpdateAdditionalInfo, isFetchingAdditionalInfo, onGetAdditionalInfoActualData } = props
    return (
        <div className={classNames(style.container, isFetchingAdditionalInfo && style.containerFetching)}>
            <SectionTitle
                header='Описание в карточке'
                description='Вы можете отредактировать описание, которое включает в себя общие сведения, сертификаты, опыт работы, образование и т.д.'
            />
            {!additionalInfo && <Loader />}
            {additionalInfo && (
                <Description
                    additionalInfo={additionalInfo}
                    onUpdateAdditionalInfo={onUpdateAdditionalInfo}
                    onGetAdditionalInfoActualData={onGetAdditionalInfoActualData}
                />
            )}
        </div>
    )
}
